<div style="width: 800px; height: 700px;" data-cy="create-adjustment">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="create-adjustment-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="create-adjustment-header">
      <div class="section-header-title" data-cy="create-adjustment-title">
        {{ this.title }}
      </div>
      <div style="flex: 1;" data-cy="create-adjustment-header-spacer"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; display: flex; flex-direction: column; height: 100%;" data-cy="create-adjustment-content">
      <app-tdo-progress-spinner style="height: 100%;" *ngIf="isLoading" data-cy="create-adjustment-spinner"></app-tdo-progress-spinner>
      <div *ngIf="!isLoading" style="flex: 1; overflow-y: hidden;" data-cy="create-adjustment-loaded-content">

        <div *ngIf="type === 'debit'" style="display: flex; flex-direction: row; padding: 10px 10px 10px 10px" class="input-container-height" data-cy="create-adjustment-debit-action-container">
          <mat-form-field class="flex-column-item mat-select-margin" style="width:100% !important;" data-cy="create-adjustment-debit-action-field">
            <mat-label data-cy="create-adjustment-debit-action-label">Action</mat-label>
            <mat-select data-cy="adjustment-action" [(ngModel)]="selectedEnumDebitAdjustmentAction" (ngModelChange)="debitActionChanged()">
              <mat-option data-cy="adjustment-action-option" *ngFor="let action of enumDebitAdjustmentActions" [value]="action">
                {{ action.ItemDisplayValue }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div *ngIf="type === 'debit' && (this.selectedEnumDebitAdjustmentAction && this.selectedEnumDebitAdjustmentAction.ValidValueItemId === this.enumDebitAdjustmentActionIssueCreditCardRefund)" style="height: 300px;display: flex; flex-direction: column; padding: 10px 10px 10px 10px;overflow:auto;" data-cy="create-adjustment-credit-card-refund">
          <div data-cy="create-adjustment-refund-amount">Refund Amount: {{ this.CCRefundAmountToRefund | currency }}</div>

          <table mat-table #ccRefundTable [dataSource]="paymentRecordsCC" data-cy="create-adjustment-cc-refund-table">

            <ng-container matColumnDef="PaymentTransactionDate">
              <th mat-header-cell *matHeaderCellDef class="matCellyHeader" data-cy="create-adjustment-cc-refund-header-date">Date</th>
              <td class="matCelly" mat-cell *matCellDef="let element" data-cy="create-adjustment-cc-refund-cell-date"> {{ element.PaymentTransactionDate | date }} </td>
            </ng-container>

            <ng-container matColumnDef="Description">
              <th mat-header-cell *matHeaderCellDef class="matCellyHeader" data-cy="create-adjustment-cc-refund-header-desc">Description</th>
              <td class="matCelly" mat-cell *matCellDef="let element" data-cy="create-adjustment-cc-refund-cell-desc"> {{ element.Description }} </td>
            </ng-container>

            <ng-container matColumnDef="ARAccountName">
              <th mat-header-cell *matHeaderCellDef class="matCellyHeader" data-cy="create-adjustment-cc-refund-header-account">AR Account</th>
              <td class="matCelly" mat-cell *matCellDef="let element" data-cy="create-adjustment-cc-refund-cell-account"> {{ element.ARAccountName }} </td>
            </ng-container>

            <ng-container matColumnDef="PaymentAmount">
              <th mat-header-cell *matHeaderCellDef class="matCellyHeader" data-cy="create-adjustment-cc-refund-header-payment">Payment</th>
              <td class="matCelly" mat-cell *matCellDef="let element" data-cy="create-adjustment-cc-refund-cell-payment"> {{element.PaymentAmount | currency }} </td>
            </ng-container>

            <ng-container matColumnDef="AmountAvailable">
              <th mat-header-cell *matHeaderCellDef class="matCellyHeader" data-cy="create-adjustment-cc-refund-header-available">Available</th>
              <td class="matCelly" mat-cell *matCellDef="let element" data-cy="create-adjustment-cc-refund-cell-available"> {{element.AvailableAmount | currency }} </td>
            </ng-container>

            <ng-container matColumnDef="Refund">
              <th mat-header-cell *matHeaderCellDef class="matCellyHeader" data-cy="create-adjustment-cc-refund-header-refund">Refund</th>
              <td class="matCelly" mat-cell *matCellDef="let element" data-cy="create-adjustment-cc-refund-cell-refund">
                <div *ngIf="element.IsDistribution"  class="input-container-table-height" data-cy="create-adjustment-cc-refund-input-container">
                  <mat-form-field style="width:100px" data-cy="create-adjustment-cc-refund-field">
                    <input [disabled]="!this.CCRefundIsParentChecked(element.PaymentID)" [style.background]="getNumber(element.Refund) > element.PaymentAmount ? 'red' :''" [value]="element.Refund" matInput appCurrencyFormatter (change)="this.onUpdateCCRefundAmount($event, element)" [autocomplete]="false" required data-cy="create-adjustment-cc-refund-input">
                  </mat-form-field>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="PaymentID">
              <th mat-header-cell *matHeaderCellDef class="matCellyHeader" data-cy="create-adjustment-cc-refund-header-checkbox"></th>
              <td class="matCelly" mat-cell *matCellDef="let element" data-cy="create-adjustment-cc-refund-cell-checkbox">
                <mat-checkbox *ngIf="element.IsPayment" data-cy="cc-refund-cb" [(ngModel)]="element.isChecked" (ngModelChange)="refundCCChecked(element.PaymentID)"></mat-checkbox>
              </td>
            </ng-container>
            <tr mat-header-row class="top-under-header-row" *matHeaderRowDef="CCRefundTableColumns;"></tr>
            <tr data-cy="cc-refund-item-row" mat-row *matRowDef="let row; columns: CCRefundTableColumns;" (contextmenu)="$event.preventDefault(); onCCRefundRowContextMenu($event, row)" (click)="onCCRefundRowSelectedClick(row)"></tr>

          </table>

        </div>

        <div *ngIf="type === 'debit' && (this.selectedEnumDebitAdjustmentAction && this.selectedEnumDebitAdjustmentAction.ValidValueItemId === this.enumDebitAdjustmentActionIssueCheckInQuickBooks)" style="height: 200px;display: flex; flex-direction: column; padding: 10px 10px 10px 10px" data-cy="create-adjustment-quickbooks-refund">
          <div data-cy="create-adjustment-credits-heading">List of Available Credits for Refund</div>
          <div style="flex: 1; overflow-y: auto; margin-top: 2px;" data-cy="credits-table">

            <tdo-table
              [isStickyHeader]="true"
              [dataSource]="ledgerItemsCredits"
              [isMultiSelection]="false"
              [isSearchable]="false"
              [isUsePaginator]="false"
              (rowSelected)="onCreditRowSelected($event)"
              data-cy="create-adjustment-credits-table">
              <tdo-table-column displayName="Post Date" propertyName="PostDate" isSortable="true" [rowTemplate]="postDate" data-cy="create-adjustment-credits-col-date">
                <ng-template #postDate let-row>
                  <div matTooltip="{{ convertUTCDatetoTimezone(row.PostDate, this.TZID) | date:'medium' }}" data-cy="create-adjustment-credits-date">
                    {{ convertUTCDatetoTimezone(row.PostDate, this.TZID) | date }}
                  </div>
                </ng-template>
              </tdo-table-column>
              <tdo-table-column displayName="Reference" propertyName="Reference" isSortable="true" [rowTemplate]="ref" data-cy="create-adjustment-credits-col-reference">
                <ng-template #ref let-row>
                  <div *ngIf="row.model.Reference" style="max-width: 300px; white-space: pre-line" data-cy="create-adjustment-credits-reference">
                    {{ row.model.Reference }}
                  </div>
                </ng-template>
              </tdo-table-column>
              <tdo-table-column displayName="Description" propertyName="Description" isSortable="true" [rowTemplate]="description" data-cy="create-adjustment-credits-col-description">
                <ng-template #description let-row>
                  <div *ngIf="row.model.Description && row.model.Description" style="max-width: 300px; white-space: pre-line" data-cy="create-adjustment-credits-description">
                    {{ row.model.Description }}
                  </div>
                </ng-template>
              </tdo-table-column>
              <tdo-table-column displayName="Credit" propertyName="Amount" [rowTemplate]="amt" data-cy="create-adjustment-credits-col-amount">
                <ng-template #amt let-row>
                  <div *ngIf="row.model.Amount" data-cy="create-adjustment-credits-amount">
                    {{ row.model.Amount | currency }}
                  </div>
                </ng-template>
              </tdo-table-column>
              <tdo-table-column displayName="Refund" propertyName="RefundAmount" [rowTemplate]="refund" data-cy="create-adjustment-credits-col-refund">
                <ng-template #refund let-row>
                  <div class="input-container-table-height" data-cy="create-adjustment-credits-refund-container">
                    <mat-form-field style="width:100px" data-cy="create-adjustment-credits-refund-field">
                      <input [id]="'refundRow' + row.model.LedgerID" [disabled]="!row.model.RefundChecked" [value]="row.model.RefundAmount" matInput appCurrencyFormatter (change)="onUpdateRefundAmount($event, row.model)" [autocomplete]="false" data-cy="create-adjustment-credits-refund-input">
                    </mat-form-field>
                  </div>

                </ng-template>
              </tdo-table-column>
              <tdo-table-column displayName="" propertyName="RefundChecked" [rowTemplate]="refundChecked" data-cy="create-adjustment-credits-col-checkbox">
                <ng-template #refundChecked let-row>
                  <mat-checkbox [(ngModel)]="row.model.RefundChecked" (ngModelChange)="refundRowChecked(row.model.LedgerID, row.model.RefundAmount)" data-cy="create-adjustment-credits-checkbox"></mat-checkbox>
                </ng-template>
              </tdo-table-column>
            </tdo-table>
          </div>
        </div>

        <div style="display: flex; flex-direction: row; padding: 10px 10px 10px 10px" data-cy="create-adjustment-amount-date-row">
          <div *ngIf="type === 'debit' && (this.selectedEnumDebitAdjustmentAction && this.selectedEnumDebitAdjustmentAction.ValidValueItemId === this.enumDebitAdjustmentActionIssueCheckInQuickBooks)" style="flex-basis: 50%" class="input-container-height" data-cy="create-adjustment-total-amount">
            <b data-cy="create-adjustment-total-amount-label">Total Amount</b><br>
            <span data-cy="create-adjustment-total-amount-value">{{ ledgerItem.Amount | currency }}</span>
          </div>
          <div *ngIf="!(type === 'debit' && (this.selectedEnumDebitAdjustmentAction && this.selectedEnumDebitAdjustmentAction.ValidValueItemId === this.enumDebitAdjustmentActionIssueCheckInQuickBooks))" style="flex-basis: 50%" class="input-container-height" data-cy="create-adjustment-amount-container">
            <mat-form-field style="width:100px" data-cy="create-adjustment-amount-field">
              <mat-label data-cy="create-adjustment-amount-label">Amount</mat-label>
              <input data-cy="adjustment-amount" [readonly]="(this.selectedEnumDebitAdjustmentAction && this.selectedEnumDebitAdjustmentAction.ValidValueItemId !== this.enumDebitAdjustmentActionDebitPatientAccount) || this.paymentToVoid" [id]="'debitAmount'"
                  matInput appCurrencyFormatter [autocomplete]="false" [(ngModel)]="ledgerItem.Amount" required>
            </mat-form-field>
          </div>
          <div style="flex-basis: 50%" class="input-container-height" data-cy="create-adjustment-date-container">
            <mat-form-field class="flex-column-item mat-select-margin" style="width:100% !important;" data-cy="create-adjustment-date-field">
              <mat-label data-cy="create-adjustment-date-label">Date Received</mat-label>
              <input data-cy="adjustment-date" matInput [matDatepicker]="dateReceivedPicker" [(ngModel)]="selectedDate" autocomplete="false" required>
              <mat-datepicker-toggle matSuffix [for]="dateReceivedPicker" data-cy="create-adjustment-date-toggle"></mat-datepicker-toggle>
              <mat-datepicker #dateReceivedPicker data-cy="create-adjustment-date-picker"></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div style="display: flex; flex-direction: column; padding: 10px 10px 10px 10px" data-cy="create-adjustment-details">

          <div data-cy="adjustment-reason" style="flex-basis: 40px; position: relative;" class="input-container-height" (contextmenu)="openEditReasons($event); $event.preventDefault();">

            <mat-form-field class="flex-column-item mat-select-margin" style="width:100% !important;" data-cy="create-adjustment-reason-field">
              <mat-label data-cy="create-adjustment-reason-label">Reason</mat-label>
              <mat-select data-cy="reason-list" [(ngModel)]="selectedCreditDebitReason" required>
                <mat-option data-cy="reason-list-option" *ngFor="let reason of creditDebitReasons" [value]="reason">
                  {{ reason.Reason }}
                </mat-option>
              </mat-select>
            </mat-form-field>

          </div>
          <div style="display: flex; flex-direction: row" *ngIf="(this.selectedEnumDebitAdjustmentAction &&
          this.selectedEnumDebitAdjustmentAction.ValidValueItemId === this.enumDebitAdjustmentActionDebitPatientAccount ) || !this.selectedEnumDebitAdjustmentAction" data-cy="create-adjustment-ledger-item-container">
            <div style="flex-basis: 90%" class="input-container-height" data-cy="create-adjustment-ledger-item-field-container">
              <mat-form-field style="width:100%" data-cy="create-adjustment-ledger-item-field">
                <mat-label data-cy="create-adjustment-ledger-item-label">Ledger Item Reference</mat-label>
                <input data-cy="ledger-item" [readonly]="this.type === 'void-payment'" matInput autocomplete="off" [(ngModel)]="this.ledgerItemText" required>
              </mat-form-field>
            </div>
            <div style="flex-basis: 10%; text-align: right" data-cy="create-adjustment-ledger-item-button-container">
              <button data-cy="choose-ledger-item-btn" [disabled]="this.type == 'void-payment'" mat-mini-fab color="primary" aria-label="Choose Ledger Item"
                      (click)="openChooseLedgerItemWindow()"
                      matTooltip="Choose Ledger Item">
                <mat-icon data-cy="create-adjustment-ledger-item-button-icon">more_horiz</mat-icon>
              </button>
            </div>
          </div>
          <div class="input-container-height" data-cy="create-adjustment-location-container">
            <mat-form-field class="flex-column-item mat-select-margin" style="width:100% !important;" data-cy="create-adjustment-location-field">
              <mat-label data-cy="create-adjustment-location-label">Location</mat-label>
              <mat-select data-cy="location-list" [(ngModel)]="selectedLocation" (selectionChange)="this.onLocationChange()" [disabled]="this.type === 'void-payment'">
                <mat-option data-cy="location-list-option" *ngFor="let location of locations" [value]="location" [required]="requiredLocation">
                  {{ location.Name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="input-container-height" *ngIf="(this.selectedEnumDebitAdjustmentAction && this.selectedEnumDebitAdjustmentAction.ValidValueItemId === this.enumDebitAdjustmentActionDebitPatientAccount) || !this.selectedEnumDebitAdjustmentAction" data-cy="create-adjustment-ar-account-container">
            <mat-form-field class="flex-column-item mat-select-margin" style="width:100% !important;" data-cy="create-adjustment-ar-account-field">
              <mat-label data-cy="create-adjustment-ar-account-label">AR Account</mat-label>
              <mat-select data-cy="ar-account-list" [(ngModel)]="selectedARAccount" [disabled]="!arAccounts" [disabled]="this.type === 'void-payment'">
                <mat-option data-cy="ar-account-list-option" *ngFor="let account of arAccounts" [value]="account">
                  {{ account.AccountName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="input-container-height" data-cy="create-adjustment-note-container">
            <mat-form-field style="width:100%" data-cy="create-adjustment-note-field">
              <mat-label data-cy="create-adjustment-note-label">Notes</mat-label>
              <input data-cy="adjustment-note" matInput autocomplete="off" [(ngModel)]="this.adjustmentNote" [required]="requiredNotes">
            </mat-form-field>
          </div>
        </div>

      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px;" data-cy="create-adjustment-footer">
      <div data-cy="create-adjustment-footer-messages">
        <div *ngIf="isDoctorARQuickBooksIntegration" class="footer-message" style="color: green;" data-cy="create-adjustment-qb-message">Refund will be recorded in QuickBooks</div>
        <div *ngIf="footerMessage!== ''" class="footer-message" data-cy="create-adjustment-footer-message">{{footerMessage}}</div>
      </div>
      <div style="flex: 1; margin-right: 6px;" data-cy="create-adjustment-footer-spacer"></div>
      <button (click)="close(false)" class="tdo-button tdo-close" style="margin-right: 10px; margin-top: 10px;" data-cy="create-adjustment-cancel-btn">Cancel</button>
      <button (click)="save()" class="tdo-button tdo-save" style="margin-right: 6px; margin-top: 10px;"
      [disabled]="!this.readyToSave()" data-cy="create-adjustment-save-btn">Ok</button>
    </div>

    <ng-template #editReasonContext let-data>
      <section class="image-context-menu" data-cy="create-adjustment-reason-context-menu">
        <div data-cy="context-menu-edit-reasons-btn" (click)="openDebitCreditReasons()" class="item">Edit List</div>
      </section>
    </ng-template>
  </div>
</div>
